import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
//

//namespace SlotGames {

export class LuckyFire50Delux_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

    protected override helpFactory: IHelpFactory = new LuckyFire50DeluxHelpFactory();
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "yellow",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

    //public override isDeluxGame: boolean = true;
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "LuckyFire50Delux") {
        super(multigameParams, initData,gameName );

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }

}
class LuckyFire50DeluxHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckyFire50DeluxHelp(params);
    }
}

class LuckyFire50DeluxHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}


